'use client'

import { createContext } from 'react'
import { ClientEnvironment } from '.'

export const ClientEnvironmentContext = createContext<
  ClientEnvironment | undefined
>(undefined)
